import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

const actionsPrefix = 'app-job-search/i18n';

// initial state
export const INITIAL_STATE = {
  country: 'gb',
  language: 'en',
  translations: {},
  options: {}
};

// setters (actions)
export const setCountry = createAction(`${actionsPrefix}/SET_COUNTRY`);
export const setLanguage = createAction(`${actionsPrefix}/SET_LANGUAGE`);
export const setTranslations = createAction(`${actionsPrefix}/SET_TRANSLATIONS`);
export const setOptions = createAction(`${actionsPrefix}/SET_OPTIONS`);
export const setAll = createAction(`${actionsPrefix}/SET_ALL`);

// reducers state => newState
export default handleActions({
  [setCountry]: (state, { payload: country }) => ({ ...state, country }),
  [setLanguage]: (state, { payload: language }) => ({ ...state, language }),
  [setTranslations]: (state, { payload: translations }) => ({ ...state, translations }),
  [setOptions]: (state, { payload: options }) => ({ ...state, options }),
  [setAll]: (state, { payload: { country, language, translations, options } }) => ({
    ...state,
    country,
    language,
    translations,
    options
  })
}, INITIAL_STATE);

// getters (selectors)
export const get = state => state.i18n;
export const getCountry = createSelector(get, ({ country }) => country);
export const getLanguage = createSelector(get, ({ language }) => language);
export const getTranslations = createSelector(get, ({ translations }) => translations);
export const getOptions = createSelector(get, ({ options }) => options);
